<template>
    <div class="collapse-options">
        <a
            href="#"
            class="collapse-options__toggle"
            :class="{ open: value }"
            role="button"
            @click.prevent="toggle"
        >
            <span>{{ schema.textValue }}</span>
            <span class="collapse-options__caret" aria-hidden="true"></span>
        </a>
    </div>
</template>

<script>
    import { abstractField } from 'vue-form-generator'

    export default {
        mixins: [ abstractField ],
        methods: {
            toggle () {
                this.value = !this.value
            }
        }
    }
</script>

<style scoped>
    .collapse-options {
        width: 100%;
        text-align: left;
        padding-top: 2px;
    }

    .collapse-options__toggle {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        color: #337ab7;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.4;
        text-decoration: none;
        cursor: pointer;
        user-select: none;
    }

    .collapse-options__toggle:hover,
    .collapse-options__toggle:focus {
        color: #23527c;
        text-decoration: underline;
    }

    /* Bootstrap-style caret */
    .collapse-options__caret {
        display: inline-block;
        width: 0;
        height: 0;
        margin-top: 2px;
        border-top: 4px dashed;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
        vertical-align: middle;
        transition: transform 0.15s ease;
    }

    .collapse-options__toggle.open .collapse-options__caret {
        transform: rotate(180deg);
        margin-top: 0;
    }
</style>
